import React from "react";
import { connect } from 'react-redux';
import _ from "lodash";

import {Grid} from "@material-ui/core";

import BaseDialog from "../../../components/BaseDialog/BaseDialog";
import {PortfolioManagerResource} from "../../../utils/api";
import {displaySuccessSnackBar, displayWarningSnackBar} from "../../../components/SnackbarProvider/actions";
import AssetForm from "../AssetForm";
import PrimaryButton from "../../../components/Buttons/PrimaryButton";
import {useTabsSharedDataContext} from "../../CustomerDashboardV2/components_v2/TabsSharedData/TabsSharedData";
import {getDetailsUrl, getErrorMsg} from "../utils";
import useFormController from "../hooks/useFormController";
import LinkedItemsSection from "../LinkedItemsSection";
import {LOADING_MSG} from "../constants";
import useContractDetails from "../hooks/useContractDetails";
import ContractDetailsLoader from "../AssetForm/components/ContractDetailsLoader";
import {getFormScheme, getNewCategoryToMove} from "../AssetForm/forms_schemes";
import DynamicForm from "../AssetForm/components/DynamicForm";


const EditAssetModal = (props) => {
  const {
    dispatch,
    customerId,
    asset,
    groupId,
    assetTypeLabel,
    onModalClose,
    onAssetEdit,
    objectType,
    itemsForLinks,
    ...dialogProps
  } = props;

  const dynamicFormScheme = getFormScheme(groupId, asset.sub_category, asset.type_id);

  const [
    formData, setFormData, formDataErrors, setFormDataErrors, checkForUnsavedChanges,
    linkedItems, setLinkedItems, validateForm, handleFormChange
  ] = useFormController(dynamicFormScheme, !!dynamicFormScheme ? asset : {}, asset.linkedItems);
  const [assetEditRequestLoading, setAssetEditRequestLoading] = React.useState(false);

  const onAssetUpdate = React.useCallback((data) => {
    const newData = {...data, links: linkedItems};
    onAssetEdit(newData, false);
    setFormData(newData);
  }, [onAssetEdit, linkedItems]);
  const fetchState = useContractDetails(customerId, asset, onAssetUpdate, dialogProps.open);

  const sharedData = useTabsSharedDataContext();

  const handleClose = async () => {
    if(await checkForUnsavedChanges(handleEditAsset)){
      onModalClose();
    }
  };

  const handleEditAsset = () => {
    if(!validateForm()) return;

    setAssetEditRequestLoading(true);
    const Resource = _.get(sharedData, 'resource', PortfolioManagerResource);
    Resource.at(getDetailsUrl(customerId, asset)).patch({...formData, links: linkedItems})
    .then((res) => {
      setFormDataErrors({});
      dispatch(displaySuccessSnackBar('Änderungen übernommen.'));
      onAssetEdit({...res, links: linkedItems});
    })
    .catch(error => {
      getErrorMsg(dispatch, error, setFormDataErrors);
    }).finally(() => setAssetEditRequestLoading(false));
  };

  const newCategoryToMove = React.useMemo(() => {
    return getNewCategoryToMove(formData, groupId)
  }, [groupId, formData]);

  React.useEffect(() => {
    if(!!newCategoryToMove && linkedItems.length){
      dispatch(displayWarningSnackBar(
        `Wenn Sie die ${newCategoryToMove.fieldChanged} ändern, werden bestehende Verknüpfungen entfernt.`
      ))
    }
  }, [!!newCategoryToMove, linkedItems.length])

  return (
    <BaseDialog
      {...dialogProps}
      title={`${assetTypeLabel} bearbeiten`}
      data-id={'other-assets-and-liabilities-edit-popup'}
      handleClose={handleClose}
      maxWidth={'md'}
      disableEnforceFocus
      modalLoading={assetEditRequestLoading}
      modalLoadingMsg={LOADING_MSG}
      actions={
        <Grid container spacing={1} justify={"flex-end"}>
          <Grid item>
            <PrimaryButton onButtonClick={handleClose} color="secondary" text={'Abbrechen'} variant={'outlined'}/>
          </Grid>
          <Grid item>
            <PrimaryButton
              onButtonClick={handleEditAsset}
              text={'Übernehmen'}
              disabled={fetchState.loading || !!fetchState.error}
            />
          </Grid>
        </Grid>
      }
    >
      <Grid container spacing={2}>
        <ContractDetailsLoader fetchState={fetchState}>
          {!!dynamicFormScheme ? (
            <DynamicForm
              schema={dynamicFormScheme}
              defaults={formData}
              handleFormChange={handleFormChange}
              errors={formDataErrors}
            />
          ) : (
            <AssetForm
              categoryId={asset.type_id}
              defaults={asset}
              setFormData={setFormData}
              formDataErrors={formDataErrors}
              customerId={customerId}
            />
          )}
          {!newCategoryToMove && (
            <LinkedItemsSection
              objectType={objectType}
              itemsForLinks={itemsForLinks}
              currentLinkedItems={linkedItems}
              setLinkedItems={setLinkedItems}
              mainItemTypeId={asset.type_id}
            />
          )}
        </ContractDetailsLoader>
      </Grid>
    </BaseDialog>
  )
};

export default connect()(EditAssetModal);